import React from 'react';
import type { ResultSectionConfig } from '../../utils/types';
import { useI18n } from '../../i18n/I18nContext';
import { useFontSizes } from '../../contexts/FontSizeContext';
import { safeUrl, openInWorkingTab } from '../../utils/navigate';

interface PageResult {
  id: string;
  title: string;
  url: string;
  excerpt?: string;
}

interface PageResultsWidgetProps {
  config: ResultSectionConfig;
  pages: PageResult[];
}

export const PageResultsWidget: React.FC<PageResultsWidgetProps> = ({
  config,
  pages,
}) => {
  const { t } = useI18n();
  const { body, small } = useFontSizes();

  if (pages.length === 0) return null;

  const items = config.maxItems ? pages.slice(0, config.maxItems) : pages;

  return (
    <section className="mb-8">
      <h3 className={`${small} font-semibold uppercase tracking-wider text-gray-500 mb-4`}>
        {config.title ?? t('section.pages')}{' '}
        <span className="ml-1.5 text-gray-400 font-normal">({items.length})</span>
      </h3>
      <div className="flex flex-col gap-2">
        {items.map((page) => (
          <a
            key={page.id}
            href={safeUrl(page.url)}
            onClick={(e) => openInWorkingTab(page.url, e)}
            className="block px-4 py-3 bg-white rounded-xl border border-gray-100 hover:border-[#f02e69]/20 hover:shadow-sm transition-all"
          >
            <h4 className={`${body} font-medium text-gray-800 line-clamp-1`}>{page.title}</h4>
            {page.excerpt && (
              <p className={`${small} text-gray-500 line-clamp-1 mt-1`}>{page.excerpt}</p>
            )}
          </a>
        ))}
      </div>
    </section>
  );
};
